import {mediaMatch} from "../../../utils";

const initialState = {
  goodsListLoading: true,
  categorys: [],
  categoryActive: false,
  goodsList: [],
  query: {
    page: 1,
    limit: mediaMatch.isMdmax ? 8 : 12,
    state: 1,
  },
  total: 0,
  minPrice:'',
  maxPrice:'',
};

function reducer(state, action) {
  switch (action.type) {
    case 'setGoodsListLoading':
      return { ...state, goodsListLoading: action.payload };
    case 'setCategorys':
      return { ...state, categorys: action.payload };
    case 'setCategoryActive':
      return { ...state, categoryActive: action.payload };
    case 'setGoodsList':
      return { ...state, goodsList: action.payload };
    case 'setQuery':
      return { ...state, query: action.payload };
    case 'setTotal':
      return { ...state, total: action.payload };
    case 'setMinPrice':
      return { ...state, minPrice: action.payload };
    case 'setMaxPrice':
      return { ...state, maxPrice: action.payload };
    default:
  }
}

const setMinPrice = payload => ({
  type: 'setMinPrice',
  payload
});

const setMaxPrice = payload => ({
  type: 'setMaxPrice',
  payload
});

const setGoodsListLoading = payload => ({
  type: 'setGoodsListLoading',
  payload
});

const setCategorys = payload => ({
  type: 'setCategorys',
  payload
});


const setCategoryActive = payload => ({
  type: 'setCategoryActive',
  payload
});

const setGoodsList = payload => ({
  type: 'setGoodsList',
  payload
});

const setQuery = payload => ({
  type: 'setQuery',
  payload
});

const setTotal = payload => ({
  type: 'setTotal',
  payload
});

export {
  initialState,
  reducer,
  setMinPrice,
  setMaxPrice,
  setGoodsListLoading,
  setCategorys,
  setCategoryActive,
  setGoodsList,
  setQuery,
  setTotal
};
